import { Input, Component } from '@angular/core';
import { BaseCardConfiguration } from 'app/core/components/workflow-new/common/base-card-configuration';
import { RxComponent } from 'app/shared/components/common/rx.component';

@Component({
    selector: '',
    template: '',
})
export class CardPresentationComponent extends RxComponent {
    @Input() platformClass: any;
    @Input() public conf: BaseCardConfiguration;
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/common/card-presentation.ts